import React from "react";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import LandscapeIcon from "@mui/icons-material/Landscape";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import StatCard from "./StatCard";

const StatsSection = ({ stats }) => {
  const { t } = useTranslation();

  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 3 }}>
      <StatCard
        title={t("Total Farmers")}
        value={stats.totalFarmers}
        icon={<PeopleAltIcon />}
      />
      <StatCard
        title={t("Total Farms")}
        value={stats.totalFarms}
        icon={<LocationOnIcon />}
      />
      <StatCard
        title={t("Total Area")}
        value={stats.totalArea}
        icon={<LandscapeIcon />}
      />
    </Stack>
  );
};

export default StatsSection;
